import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';

@Injectable
({
  providedIn: 'root'
})

export class TimestableHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async getDevice( token: string, deviceId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( deviceId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_DEVICE_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.timestable().getDevice( token, deviceId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getService( token: string, serviceId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( serviceId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_SERVICE_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.timestable().getService( token, serviceId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

